export default "__VITE_ASSET__BLjGgz5O__"